module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/img-16-0cf5d9ee701b03950537f2a14c702044.png";